import React from 'react';
import { Grid } from '@mui/material';
import AccessControls from './AccessControls';
import ActivityLogs from './ActivityLogs';

const AccessControlsAndLogs = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <AccessControls />
      </Grid>
      <Grid item xs={12}>
        <ActivityLogs />
      </Grid>
    </Grid>
  );
};

export default AccessControlsAndLogs;
